import { gql } from '@apollo/client'

export const APP_NOTIFICATION = gql`
  subscription APP_NOTIFICATION($eventType: String!) {
    notification(eventType: $eventType) {
      id
      payload
    }
  }
`
